import { render, staticRenderFns } from "./StaticContentItemList.vue?vue&type=template&id=234bb40e"
import script from "./StaticContentItemList.vue?vue&type=script&lang=js"
export * from "./StaticContentItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports